import React, { useState } from "react";
import { FaTrash, FaShoppingCart } from "react-icons/fa";
import Header from "../components/Header";
import Footer from "../components/Footer";
const sampleWishlist = [
    { id: 1, name: "Red T-Shirt", price: "25", image: "https://picsum.photos/200/200?1" },
    { id: 2, name: "Blue Jeans", price: "45", image: "https://picsum.photos/200/200?2" },
    { id: 3, name: "Running Shoes", price: "60", image: "https://picsum.photos/200/200?3" },
    { id: 4, name: "Leather Jacket", price: "120", image: "https://picsum.photos/200/200?4" },
];
export default function WishlistPage() {
    const [wishlist, setWishlist] = useState(sampleWishlist);
    const removeItem = (id) => {
        setWishlist(wishlist.filter((item) => item.id !== id));
    };
    const addToCart = (item) => {
        alert(`${item.name} added to cart!`);
    };
    return (
        <div>
            <Header />
            <div className="wishlist-container">
                <h2 style={{ width: "100%", textAlign: "center" }}>My Wishlist</h2>
                <div className="gradient-line"></div>
                <div>
                    {wishlist.length === 0 ? (
                        <p className="empty-msg">Your wishlist is empty!</p>
                    ) : (
                        <div className="wishlist-grid">
                            {wishlist.map((item) => (
                                <div className="wishlist-card">
                                    <div className="product-image">
                                        <img src={item?.image || `https://picsum.photos/400/400?random=${item?.name}`} alt={item?.name} />
                                    </div>
                                    <div className="product-info">
                                        <p className="product-name">{item?.name}</p>
                                        <p className="product-price">₹{item?.price}</p>
                                        <div className="wishlist-actions">
                                            <button onClick={() => addToCart(item)}><FaShoppingCart /> Add to Cart</button>
                                            <button onClick={() => removeItem(item.id)} ><FaTrash /> Remove</button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}